document.addEventListener('DOMContentLoaded', () => {
  const target = document.querySelector('.collection__main-area');
  
  if (!target) return;
  
  const initSwipers = () => {
    document.querySelectorAll('.swiper[class*="product-slider-"]').forEach((el) => {
      const match = el.className.match(/product-slider-(\d+)/);
      if (!match) return;
      const id = match[1];
  
      if (el.swiper) {
        el.swiper.destroy(true, true);
      }
  
      new Swiper(`.product-slider-${id}`, {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 0,
        navigation: {
          nextEl: `.swiper-button-next-${id}`,
          prevEl: `.swiper-button-prev-${id}`,
        },
      });
    });
  };
  
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)) {
        console.log('Collection changed, reinitializing Swipers...');
  
        observer.disconnect();
  
        initSwipers();
  
        observer.observe(target, {
          childList: true,
          subtree: true,
        });
  
        break;
      }
    }
  });
  
  observer.observe(target, {
    childList: true,
    subtree: true,
  });
  
  initSwipers();
});